import { useIntl } from "react-intl";
import { GiftCardIcon } from "../../../assets/SVGs/SVGs";
import SubInfo from "./SubInfo";
type Props = { data: any };

const SaleCardGiftCard = ({ data }: Props) => {
  console.log(data);
  const intl = useIntl();
  return (
    <div
      style={{ border: "1px solid #EEF0FF" }}
      className="flex flex-col items-center justify-between w-full gap-2 px-3 py-2 rounded-lg"
    >
      <div className="flex items-center justify-start w-full gap-2 text-color-primary">
        <span>{GiftCardIcon}</span>
        <span>
          {intl.formatMessage({
            id: "gift_card",
          })}{" "}
          #{data?.itemable_id}
        </span>
      </div>
      <div className="flex items-center justify-between w-full">
        <SubInfo
          value={
            data?.itemable?.gift_card?.voucher_duration?.days_difference.split(
              " "
            )[0]
          }
          label={intl.formatMessage({
            id: "day",
          })}
        />
        <SubInfo
          value={data?.itemable?.value}
          label={intl.formatMessage({
            id: "SARshort",
          })}
        />
      </div>
    </div>
  );
};

export default SaleCardGiftCard;
